module.exports = __webpack_public_path__ + "static/assets/d5db1ba1f71528eba6123805a220266e.png";